
export const types = {
    comprasLoadList: '[compras] load list',
    comprasLoadDetail: '[compras] load detail',
    comprasLoadItems: '[compras] load items',
    comprasAddItem: '[compras] add item',
    comprasDuplicateItem: '[compras] duplicate item',
    comprasRemoveItem: '[compras] remove item',
    comprasUpdateTotales: '[compras] update totales',
    comprasSetNewIds: '[compras]set new ids',
    comprasUpdateSetForm: '[compras]update set form',
    comprasUpdateInfoDoc: '[compras]update info doc',

    comprasAddPagos: '[compras]add pagos',
}